module.exports = __webpack_public_path__ + "img/vertical_4_6_8003.07d08eb0.png";